import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { DiagnosticCollectionFormValue } from '../index'
import { DefaultDiagnosticCollectionValues } from '../diagnostic-collection-state-manager'
import { css } from '@emotion/css'

export function DiagnosticCollectionButtonStop({
  onClick,
  formValue
}: {
  onClick: (value: DiagnosticCollectionFormValue) => void
  formValue: DiagnosticCollectionFormValue
}) {
  const { formatMessage } = useIntl()
  return (
    <Button
      variant="destructive"
      className={css`
        font-size: 14px;
      `}
      // set formValues back to default, indicating Diagnostic Collection is stopped and disabled
      onClick={() => {
        formValue = DefaultDiagnosticCollectionValues
        onClick(formValue)
      }}
    >
      {formatMessage({ id: 'action_stop' })}
    </Button>
  )
}
